import React from 'react';
import css from './index.module.scss';

interface BackgroundTextProps {
  children: string;
}

export const BackgroundText = (props: BackgroundTextProps) => {
  return <span className={css.container}>{props.children}</span>;
};
